import {PENDING, LOADED, HIDDEN} from '../utils/constants';

export const ADAPTIVE_LAYOUT_MODULES = 'ADAPTIVE_LAYOUT_MODULES';

const setAdaptiveLayoutModules = (moduleName, ok) => {
    return {
        type: ADAPTIVE_LAYOUT_MODULES,
        payload: {moduleName, moduleStatus: ok ? LOADED : HIDDEN},
    };
};

export const moduleLoaded = (moduleName) => (dispatch) => {
    dispatch(setAdaptiveLayoutModules(moduleName, true));
};

export const moduleHidden = (moduleName) => (dispatch) => {
    dispatch(setAdaptiveLayoutModules(moduleName, false));
};

export const moduleStatus = (state = {}, action) => {
    switch (action.type) {
        case ADAPTIVE_LAYOUT_MODULES:
            const updatedModules = state.modules;
            if (!updatedModules) {
                return state;
            }
            const {moduleName, moduleStatus: status} = action.payload;
            const oldStatus = updatedModules[moduleName];
            if (
                oldStatus === PENDING &&
                (status === HIDDEN || status === LOADED)
            ) {
                updatedModules[moduleName] = status;
            } else {
                // eslint-disable-next-line no-console
                console.error(
                    `Expected either Loaded or Failed, ${moduleName} is still PENDING`,
                    state,
                    action
                );
            }

            return {...state, modules: updatedModules};
        default:
            return state;
    }
};
